/**
 * Section: review-cards
 *
 * Mobile / tablet: Swiper carousel with pagination dots.
 * Desktop (1024px+): static CSS grid (Swiper destroyed).
 */
if (!customElements.get('review-cards-carousel')) {
  customElements.define(
    'review-cards-carousel',
    class ReviewCardsCarousel extends HTMLElement {
      swiper = null;
      mql = window.matchMedia('(max-width: 1023px)');

      connectedCallback() {
        this.onMediaChange = this.onMediaChange.bind(this);
        this.mql.addEventListener('change', this.onMediaChange);

        if (this.mql.matches) {
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        this.mql.removeEventListener('change', this.onMediaChange);
        this.destroySwiper();
      }

      onMediaChange(event) {
        if (event.matches) {
          this.initSwiper();
          return;
        }

        this.destroySwiper();
      }

      initSwiper() {
        if (!window.Swiper || this.swiper) {
          return;
        }

        const sectionId = this.dataset.sectionId;
        const carouselEl = this.querySelector(`#review-cards-swiper-${sectionId}`);

        if (!carouselEl) {
          return;
        }

        this.swiper = new window.Swiper(carouselEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: carouselEl.querySelector('.review-cards__pagination'),
            clickable: true,
          },
          watchOverflow: true,
        });
      }

      destroySwiper() {
        if (!this.swiper) {
          return;
        }

        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    },
  );
}
